/**
 * WONE-612: /signin/email-otp/code — login OTP code-entry route.
 */

import React from "react";

import OtpCodeScreen from "./otp-code-screen";

const SignInOtpCode: React.FC = () => <OtpCodeScreen purpose="login" />;

export default SignInOtpCode;
